// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function(arg){
  return cof(arg) == 'Array';
};


//////////////////
// WEBPACK FOOTER
// ./~/react-helmet/~/core-js/modules/_is-array.js
// module id = 1038
// module chunks = 0